module.exports = __webpack_public_path__ + "static/media/youtubeIcon.1ac8e397.jpg";